//#region ../../node_modules/.pnpm/@mui+material@7.1.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.4__@emotion+_8c76256369110b2505f132f86162c9a6/node_modules/@mui/material/esm/colors/green.js
var e = {
	50: "#e8f5e9",
	100: "#c8e6c9",
	200: "#a5d6a7",
	300: "#81c784",
	400: "#66bb6a",
	500: "#4caf50",
	600: "#43a047",
	700: "#388e3c",
	800: "#2e7d32",
	900: "#1b5e20",
	A100: "#b9f6ca",
	A200: "#69f0ae",
	A400: "#00e676",
	A700: "#00c853"
};
//#endregion
export { e as default };

//# sourceMappingURL=index88.js.map